import { render, staticRenderFns } from "./CategoryLinks.vue?vue&type=template&id=6c8055be&scoped=true&"
import script from "./CategoryLinks.vue?vue&type=script&lang=js&"
export * from "./CategoryLinks.vue?vue&type=script&lang=js&"
import style0 from "./CategoryLinks.vue?vue&type=style&index=0&id=6c8055be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8055be",
  null
  
)

export default component.exports